import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appPlans = { plans: '_plan' };
var _discount = { saleOptions: '_saleSource' };
var _getAvailableAppPlansRequest = {};
var _getAvailableAppPlansResponse = {
    availableUpgrades: '_appPlans',
    availableDowngrades: '_appPlans',
    currentPlan: '_plan',
};
var _getPricingPageUrlRequest = {};
var _getPricingPageUrlResponse = {};
var _listAppPlansByAppIdRequest = {};
var _listAppPlansByAppIdResponse = { appPlans: '_appPlans' };
var _plan = { prices: '_price' };
var _price = { discount: '_discount' };
var _saleSource = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
function resolveWixAppmarketAppPlansV1AppsPlansUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/apps-plans',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/app-market/apps-plans',
                destPath: '/api',
            },
            {
                srcPath: '/api/apps-plans',
                destPath: '',
            },
            {
                srcPath: '/apps-plans',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/apps-plans',
                destPath: '',
            },
            {
                srcPath: '/apps-plans',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/apps-plans',
                destPath: '',
            },
            {
                srcPath: '/apps-plans',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/apps-plans',
                destPath: '',
            },
            {
                srcPath: '/apps-plans',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/apps-plans',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/apps-plans',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/apps-plans',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/apps-plans',
                destPath: '',
            },
            {
                srcPath: '/_api/apps-plans',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/apps-plans',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves plans for the given apps.
 *
 *
 * Also returns tax settings and currency details. Wix calculates this information
 * based on the 2-letter country code in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements)
 * format that you pass in the call's header. If you don't pass a country code in
 * the header, Wix calculates the tax settings and currency details based on the
 * call's IP address. Note that the tax settings and currency details may not resolve
 * properly if you call through a VPN.
 *
 * Prices for plans that are managed outside of Wix aren't returned.
 *
 * Consumers must pay for yearly and multi-yearly plans of your app every month.
 * For these plans this method returns the price that the consumer must pay every
 * month and not the total price for the entire year.
 *
 * > **Notes:**
 * > - The App Plans API doesn't follow any tenancy model. You don't need any permissions to call `List App Plans by App ID`.
 * > - This method only returns app plans that have been activated.
 */
export function listAppPlansByAppId(payload) {
    var _a = serializer(_listAppPlansByAppIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAppPlansByAppIdResponse, {
        _appPlans: _appPlans,
        _discount: _discount,
        _plan: _plan,
        _price: _price,
        _saleSource: _saleSource,
    }).fromJSON;
    function __listAppPlansByAppId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.appmarket.v1.app_plans',
            method: 'GET',
            methodFqn: 'wix.appmarket.app_plans.v1.AppsPlans.ListAppPlansByAppId',
            url: resolveWixAppmarketAppPlansV1AppsPlansUrl({
                protoPath: '/v1/apps-plans/{appIds}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAppPlansByAppId.fromReq = fromReq;
    __listAppPlansByAppId.__isAmbassador = true;
    return __listAppPlansByAppId;
}
/**
 * Retrieves the available app plans to upgrade and downgrade from current plan in the published version.
 * The API will get appId + it might get the combination if (vendorId + cycle).
 * In case the combination is not provided, the API will act by the current plan according to the metaSiteId.
 * The API will retrieve a list of available plans for upgrade and downgrade.
 * Upgrade plans are plans that are more expensive than the current plan.
 * Downgrade plans are plans that are less expensive than the current plan.
 * Each plan contains the productId, cycle, name, benefits and prices of the plan.
 * Every plan that is not retrieved is not supported to upgrade/downgrade from the current plan.
 */
export function getAvailableAppPlans(payload) {
    var _a = serializer(_getAvailableAppPlansRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAvailableAppPlansResponse, {
        _appPlans: _appPlans,
        _discount: _discount,
        _plan: _plan,
        _price: _price,
        _saleSource: _saleSource,
    }).fromJSON;
    function __getAvailableAppPlans(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.appmarket.v1.app_plans',
            method: 'GET',
            methodFqn: 'wix.appmarket.app_plans.v1.AppsPlans.GetAvailableAppPlans',
            url: resolveWixAppmarketAppPlansV1AppsPlansUrl({
                protoPath: '/v1/apps-plans/available-plans',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAvailableAppPlans.fromReq = fromReq;
    __getAvailableAppPlans.__isAmbassador = true;
    return __getAvailableAppPlans;
}
/**
 * Retrieves the pricing page url if there is an app plan that is eligible for upgrade in the published version.
 * The API will get appId + might get a combination of (vendorId + cycle).
 * In case the combination is not provided, the API will act by the current plan according to the metaSiteId.
 * Upgrade plans are plans that are more expensive than the current plan.
 */
export function getPricingPageUrl(payload) {
    var _a = serializer(_getPricingPageUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPricingPageUrlResponse, {}).fromJSON;
    function __getPricingPageUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.appmarket.v1.app_plans',
            method: 'GET',
            methodFqn: 'wix.appmarket.app_plans.v1.AppsPlans.GetPricingPageUrl',
            url: resolveWixAppmarketAppPlansV1AppsPlansUrl({
                protoPath: '/v1/apps-plans/pricing-page-url',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPricingPageUrl.fromReq = fromReq;
    __getPricingPageUrl.__isAmbassador = true;
    return __getPricingPageUrl;
}
//# sourceMappingURL=http.impl.js.map